"use client";
import { Box, Flex, Text } from "@radix-ui/themes";
import React from "react";
import { useSession } from "next-auth/react";
import { Session } from "next-auth";
import { Role } from "@prisma/client";
import FooterItem from "./FooterItem";
import Link from "next/link";
import { ArrowTopRightIcon } from "@radix-ui/react-icons";
import Container from "./Container";
import { usePathname, useRouter } from "next/navigation";
import { ExtendedSession } from "@/lib/interface/ExtendedSession";
import Image from "next/image";
import footerLogo from "@/public/artefact_dark.svg";

const footerData = [
  {
    label: "logo",
    content: <Image src={footerLogo} alt={`${process.env.NEXT_PUBLIC_TENANT_NAME} Logo`} width={200} height={200} />,
  },
  {
    label: `Contact ${process.env.NEXT_PUBLIC_TENANT_NAME}`,
    content: [
      { start: 'Suite 101, 5240 1A Street SE' },
      { start: 'Calgary, AB T2H 1J1' },
      { start: `${process.env.NEXT_PUBLIC_CONSIGNEE_PHONE}` },
      { start: `${process.env.NEXT_PUBLIC_CONSIGNEE_EMAIL}` },
    ],
  },
  {
    label: "Contact Biddify",
    content: (
      <Flex direction="column" className="text-center lg:text-start">
        <Text className="text-sm">Auction Platform Support</Text>
        <Text className="text-sm">(647) 375-8281</Text>
        <Link
          href="mailto:andrew@biddify.io"
          className="flex flex-row items-center gap-1"
        >
          <Text className="text-sm">andrew@biddify.io</Text>
        </Link>
      </Flex>
    ),
  },
  {
    label: "Social Media",
    content: (
      <Flex direction="column" className="gap-1">
        <Link
          href="https://www.instagram.com/artefactauction/"
          className="flex flex-row items-center gap-1"
        >
          <Text className="text-sm">Instagram</Text>
          <ArrowTopRightIcon />
        </Link>
        <Link
          href="https://www.facebook.com/artefact.auction.yyc/"
          className="flex flex-row items-center gap-1"
        >
          <Text className="text-sm">Facebook</Text>
          <ArrowTopRightIcon />
        </Link>
      </Flex>
    ),
  },
];

const EXCLUDE_FOOTERS_REGEXES = [
  "/auth/signin",
  "/auctions/\\d+/portal",
  "/verify",
  "/email/verify/send",
  "/password",
  "/account",
  "/watchlist",
];

const Footer = ({ session }: { session: ExtendedSession | null }) => {
  const pathname = usePathname();

  // Check if we're on a not-found page by checking if the current route matches any known routes
  const isNotFound = pathname === '/404' || pathname === '/not-found';

  if (isNotFound || EXCLUDE_FOOTERS_REGEXES.some((r) => new RegExp(r).test(pathname))) {
    return null;
  }

  if (session && session.role == Role.ADMIN) return null;
  return (
    <Container className="flex w-full flex-grow-0">
      <Flex direction={"column"} align={"center"} className="mt-8 w-full">
        <Flex className="h-0.5 p-0 w-full bg-[#EDE9FE]" />
        <Flex className="w-full" justify={"center"}>
          <Flex
            justify={"between"}
            className="w-full py-12 px-20 flex-col gap-4 items-center lg:flex-row lg:items-start"
          >
            {footerData.map((item, index) => (
              <FooterItem
                header={item.label}
                key={index}
                content={item.content}
              />
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};

export default Footer;

export const revalidate = 0;
